module.exports = __webpack_public_path__ + "static/media/by.26a195de.svg";